import { Grid } from "@mui/material";
import { FC } from "react";
import {
  CreditosOrganizacion,
  CreditosSuborganizacion,
  CreditosSuscripcion,
  CreditosUsario,
} from "../../../../interfaces/SuperAdmin/Pages/iDataCreditos";
import CustomInfoBox from "../CustomInfoBox";
import CustomPieChart from "../CustomPieChart";

interface Props {
  credits:
    | CreditosOrganizacion[]
    | CreditosSuborganizacion[]
    | CreditosUsario[]
    | CreditosSuscripcion[];
  title: string;
  label: string;
}

const AllEntitiesPieCharts: FC<Props> = ({ credits, title, label }) => {
  const pieCharts = [
    {
      title: "Créditos totales",
      value: "creditos_totales",
      hasCredits: credits.some((item) => item["creditos_totales"]), // Verifica si algun item tiene créditos
    },
    {
      title: "Créditos disponibles",
      value: "creditos_disponibles",
      hasCredits: credits.some((item) => item["creditos_disponibles"]),
    },
    {
      title: "Créditos gastados",
      value: "creditos_gastados",
      hasCredits: credits.some((item) => item["creditos_gastados"]),
    },
    {
      title: "Créditos desperdiciados",
      value: "creditos_desperdiciados",
      hasCredits: credits.some((item) => item["creditos_desperdiciados"]),
    },
  ];

  return (
    <Grid container spacing={2} sx={{ color: "#336B87", minHeight: "240px" }}>
      {/* Total datos */}
      <Grid item xs={12} sm={6} md={2.4}>
        <CustomInfoBox value={credits.length} title={title} />
      </Grid>

      {pieCharts.map((pie) => (
        <Grid key={pie.title} item xs={12} sm={6} md={2.4}>
          <CustomPieChart
            data={credits}
            title={pie.title}
            label={label}
            value={pie.value}
            hasCredits={pie.hasCredits}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default AllEntitiesPieCharts;
